const clubs = [
	{
		path: '/club/clubs',
		name: 'club-clubs-list',
		component: () => import('@/views/club/clubs/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGCL,clubs',
		},
	},
]

export default clubs
